import { PasswordValidator } from '@1bill-app/validators/password.validator';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EMAIL_REGEX, PASSWORD_LENGTH, PASSWORD_REGEX } from '../auth-constants';

export const matchingPasswords = new FormGroup(
  {
    password: new FormControl(
      '',
      Validators.compose([
        Validators.minLength(PASSWORD_LENGTH),
        Validators.required,
        Validators.pattern(PASSWORD_REGEX),
      ]),
    ),
    confirmPassword: new FormControl('', Validators.required),
  },
  (formGroup: FormGroup) => {
    return PasswordValidator.areEqual(formGroup);
  },
);

export const signUpForm = () => {
  return new FormGroup({
    // firstName: new FormControl('', [Validators.required]),
    // lastName: new FormControl('', [Validators.required]),
    email: new FormControl(
      '',
      Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEX)]),
    ),
    matchingPasswords,
  });
};

export const recoverPasswordForm = () => {
  return new FormGroup({
    email: new FormControl(
      '',
      Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEX)]),
    ),
  });
};

export const recoverPasswordWithCodeForm = (email: string) => {
  return new FormGroup({
    email: new FormControl(
      { value: email, disabled: true },
      Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEX)]),
    ),
    code: new FormControl('', [Validators.minLength(6), Validators.required]),
    newPassword: new FormControl(
      '',
      Validators.compose([
        Validators.minLength(PASSWORD_LENGTH),
        Validators.required,
        Validators.pattern(PASSWORD_REGEX),
      ]),
    ),
  });
};

export const unsubscribeForm = () => {
  return new FormGroup({
    email: new FormControl(
      '',
      Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEX)]),
    ),
  });
};
